export interface CreateFieldSectionPayload {
  fieldSectionName: string;
  fieldSectionType: FieldSectionType;
  fieldSectionSubType?: FieldSectionSubType;
  private?: boolean;
}

export enum FieldSectionType {
  Project = 'PROJECT',
  ProjectPhase = 'PROJECT_PHASE',
  Task = 'TASK',
  Users = 'USERS',
  Financial = 'FINANCIAL',
  Sprint = 'SPRINT',
  Company = 'COMPANY',
  Timeoff = 'TIMEOFF',
}

export enum FieldSectionSubType {
  Default = 'DEFAULT',
  Skill = 'SKILL',
  ExternalUser = 'EXTERNAL_TEAM_MEMBER',
}

export interface FieldSection extends CreateFieldSectionPayload {
  fieldSectionId: number;
  default: boolean;
  fixed: boolean;
  createdBy: number;
  fieldOrder: number[];
  readUserGroupIds?: number[] | null;
  writeUserGroupIds?: number[] | null;
}

export enum FieldTypeDisplay {
  Level = 'LEVEL',
}
